import update from 'immutability-helper';
import paymentApi from '../lib/api/payment';
import history from '../lib/history';

// ------------------------------------
// Constants
// ------------------------------------

export const SET_APPROVAL_DATA = 'PAYMENT/SET_APPROVAL_DATA';
export const SHOW_LOADING = 'PAYMENT/SHOW_LOADING';
export const HIDE_LOADING = 'PAYMENT/HIDE_LOADING';

export function setPaymentApprovalData(payResDto) {
	return {
		type: SET_APPROVAL_DATA,
		payResDto,
	};
}

export function showLoading() {
	return {
		type: SHOW_LOADING,
	};
}

function hideLoading() {
	return {
		type: HIDE_LOADING,
	};
}

export function createPaymentResource() {
	return async (dispatch, getState) => {
		const merchantId = getState().merchant.merchantId;
		const payResDto = await paymentApi.createPaymentResource(
			merchantId,
			getState().merchant.themeName,
			getState().shoppingCart.elements[merchantId].secureId);
		dispatch(setPaymentApprovalData(payResDto));
	};
}

export function createPaymentResourceIfShoppingcartNotEmpty() {
	return async (dispatch, getState) => {
		try {
			const shoppingCartEvents = getState().shoppingCart.elements[getState().merchant.merchantId].events;
			let shoppingCartNotEmpty = false;
			if (shoppingCartEvents) {
				shoppingCartNotEmpty = shoppingCartEvents.length > 0;
			}
			if (shoppingCartNotEmpty) {
				await dispatch(createPaymentResource());
				return dispatch(hideLoading());
			}
			return Promise.resolve();
		} catch (exception) {
			history.push(`${history.location.pathname.replace('payment', 'payment-error')}`);
			return Promise.reject('Error creating payment resource;');
		}
	};
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
	[SET_APPROVAL_DATA]: (state, action) =>
	update(state, {
		approvalURL: { $set: action.payResDto.redirectUrl },
		sandboxMode: { $set: action.payResDto.sandboxMode },
	}),
	[SHOW_LOADING]: (state) => update(state, {
		isLoading: { $set: true },
	}),
	[HIDE_LOADING]: (state) => update(state, {
		isLoading: { $set: false },
	}),
};

// ------------------------------------
// Reducer
// ------------------------------------
export const initialState = {
	approvalURL: '',
	sandboxMode: null,
	isLoading: true,
};

export default function reducerFunction(state = initialState, action) {
	const handler = ACTION_HANDLERS[action.type];
	return handler ? handler(state, action) : state;
}
